import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FileManager from './FileManager'
import SostaOnlineApiService from '../../services/SostaOnlineApiService'

export default class FileManagerContainer extends Component {
  static propTypes = {
    onFileSelected: PropTypes.func,
    documentTypeId: PropTypes.any
  }

  currentNewFile

  constructor (props) {
    super(props)

    this.state = {
      loading: false,
      files: [],
      documentTypes: [],
      error: null,
      showUploadForm: false,
      newDocumentFileInputTouched: false,
      newDocumentName: '',
      newDocumentType: '',
      newDocumentSubmitting: false,
      newDocumentError: null,
      validateErrors: {},
      selectedRows: []
    }

    this.toggleShowUploadForm = this.toggleShowUploadForm.bind(this)
    this.onNewFileDocumentChange = this.onNewFileDocumentChange.bind(this)
    this.onNewDocumentNameChange = this.onNewDocumentNameChange.bind(this)
    this.onNewDocumentTypeChange = this.onNewDocumentTypeChange.bind(this)
    this.onNewDocumentSubmit = this.onNewDocumentSubmit.bind(this)
    this.onRowSelected = this.onRowSelected.bind(this)
    this.onFileSubmitSelected = this.onFileSubmitSelected.bind(this)
  }

  /**
   * Questa funzione legge i primi 4 byte di un file e li ritorna in formato esadecimale.
   * P.S. di fatto questa funzione ritorna la firma di un file che possiamo confrontare con una lista di
   * magic numbers ed avere il tipo esatto di un file: jpg, pdf, tiff, etc. (usiamo questa funzione perché
   * il browser prende il mime-type dall'estensione e non dal file stesso, creando diversi problemi di sicurezza)
   *
   * @param file
   * @returns {Promise}
   */
  getFileSignature (file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      // leggiamo il file con l'evento di lettura file completata
      fileReader.onloadend = (event) => {
        if (event.target.readyState === FileReader.DONE) {
          const uint = new Uint8Array(event.target.result)
          let bytes = []
          uint.forEach((byte) => {
            bytes.push(byte.toString(16))
          })
          const hex = bytes.join('').toUpperCase()
          resolve(hex)
        }
        reject()
      }

      // qua prendiamo i primi 4 byte del file
      const blob = file.slice(0, 4)
      // leggiamo i 4 byte del file, una volta finito verrà chiamata la funzione fileReader.onloadend(event)
      fileReader.readAsArrayBuffer(blob)
    })
  }

  async componentDidMount () {
    this.setState({loading: true})
    await Promise.all([
      this.fetchUserFiles(),
      this.fetchDocumentTypes()
    ])
    this.setState({loading: false})
  }

  async fetchUserFiles () {
    const {documentTypeId} = this.props
    const response = await SostaOnlineApiService.fetchMyDocuments()

    if (response.result !== 'ok') {
      this.setState({ error: 'Errore di comunicazione con il server' })
      return
    }

    if (documentTypeId) {
      this.setState({ files: response.data.filter(item => item.DocumentTypeId === documentTypeId) })
    } else {
      this.setState({ files: response.data })
    }
  }

  async fetchDocumentTypes () {
    const response = await SostaOnlineApiService.fetchDocumentTypes()

    if (response.result !== 'ok') {
      this.setState({ error: 'Errore di comunicazione con il server' })
      return
    }

    this.setState({ documentTypes: response.data })
  }

  toggleShowUploadForm () {
    const { showUploadForm, newDocumentSubmitting } = this.state

    if (newDocumentSubmitting) {
      return
    }

    if (showUploadForm) {
      this.setState({
        newDocumentName: '',
        newDocumentType: '',
        newDocumentFileInputTouched: false,
        newDocumentError: null,
        validateErrors: {}
      })
    }
    this.setState({showUploadForm: !showUploadForm})
  }

  onNewFileDocumentChange (event) {
    console.log(event.target.files)
    if (event.target.files.length > 0) {
      this.currentNewFile = event.target.files[0]
      this.setState({
        newDocumentFileInputTouched: true,
        newDocumentName: event.target.files[0].name
      }, () => this.validateNewDocumentForm())
    }
  }

  onNewDocumentNameChange (event) {
    this.setState({newDocumentName: event.target.value}, () => this.validateNewDocumentForm())
  }

  onNewDocumentTypeChange (event) {
    this.setState({newDocumentType: event.target.value}, () => this.validateNewDocumentForm())
  }

  async onNewDocumentSubmit () {
    try {
      const { documentTypeId } = this.props
      const {
        newDocumentName,
        newDocumentType
      } = this.state

      if (!this.validateNewDocumentForm()) {
        return
      }

      const signature = await this.getFileSignature(this.currentNewFile)
      const mimeType = this.getFileMimeType(signature)

      if (mimeType === 'Unknow') {
        this.setState({
          newDocumentError: 'File non supportato. I tipi supportati sono: tiff, png, jpeg e pdf'
        })
        return
      }

      this.setState({
        newDocumentError: null,
        newDocumentSubmitting: true
      })

      let documentType = newDocumentType
      if (documentTypeId) {
        documentType = documentTypeId
      }

      const response = await SostaOnlineApiService.uploadDocument(newDocumentName, documentType, this.currentNewFile)
      console.log(response)
      if (response.result !== 'ok') {
        this.setState({
          newDocumentSubmitting: false,
          newDocumentError: 'Errore durante il caricamento del documento'
        })
        return
      }

      this.setState({loading: true}, async () => {
        await this.fetchUserFiles()
        this.setState({
          newDocumentSubmitting: false,
          loading: false
        })
        this.toggleShowUploadForm()
      })
    } catch (e) {
      this.setState({
        newDocumentSubmitting: false,
        newDocumentError: 'Errore durante il caricamento del documento'
      })
    }
  }

  onRowSelected (index, row) {
    if (!this.props.onFileSelected) {
      return
    }

    const newSelectedRows = []
    newSelectedRows.push(index)
    this.setState({selectedRows: newSelectedRows})
  }

  onFileSubmitSelected () {
    const { onFileSelected } = this.props
    const { selectedRows, files } = this.state
    if (this.props.onFileSelected && selectedRows.length > 0) {
      onFileSelected(files[selectedRows[0]])
    }
  }

  validateNewDocumentForm () {
    const { documentTypeId } = this.props
    const {newDocumentType, newDocumentName} = this.state
    let result = true
    const validateErrors = {}
    if (!this.currentNewFile) {
      validateErrors.file = 'Campo obbligatorio'
      result = false
    }

    if (newDocumentName === '' || !newDocumentName) {
      validateErrors.name = 'Campo obbligatorio'
      result = false
    }

    if (!documentTypeId && (newDocumentType === '' || !newDocumentType)) {
      validateErrors.type = 'Campo obbligatorio'
      result = false
    }

    this.setState({validateErrors: validateErrors})
    return result
  }

  getFileMimeType (magicNumber) {
    switch (magicNumber) {
      case 'FFD8FFE0': // JPEG
        return 'image/jpeg'

      case '89504E47': // PNG
        return 'image/png'

      case '25504446': // PDF
        return 'application/pdf'

      case '49492A0': // TIFF
      case '4D4D02A': // TIFF
        return 'image/tiff'

      default:
        return 'Unknow'
    }
  }

  render () {
    const {
      documentTypeId
    } = this.props
    const {
      loading,
      files,
      error,
      showUploadForm,
      documentTypes,
      newDocumentName,
      newDocumentType,
      newDocumentFileInputTouched,
      newDocumentError,
      newDocumentSubmitting,
      validateErrors,
      selectedRows
    } = this.state
    return (
      <FileManager
        error={error}
        files={files}
        loading={loading}
        showUploadForm={showUploadForm}
        documentTypes={documentTypes}
        toggleShowUploadForm={this.toggleShowUploadForm}
        onNewFileDocumentChange={this.onNewFileDocumentChange}
        newDocumentFileInputTouched={newDocumentFileInputTouched}
        newDocumentName={newDocumentName}
        newDocumentType={newDocumentType}
        onNewDocumentNameChange={this.onNewDocumentNameChange}
        onNewDocumentTypeChange={this.onNewDocumentTypeChange}
        onNewDocumentSubmit={this.onNewDocumentSubmit}
        newDocumentError={newDocumentError}
        newDocumentSubmitting={newDocumentSubmitting}
        newDocumentValidateErrors={validateErrors}
        onRowSelected={this.onRowSelected}
        selectedRows={selectedRows}
        onFileSubmitSelected={this.onFileSubmitSelected}
        documentTypeId={documentTypeId}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FileManager/FileManagerContainer.js